module.exports = __webpack_public_path__ + "static/media/plan.29298b75.svg";